import React, { Component,Fragment } from 'react';
import ReturnPageHeader from "pages/returnCheckout/ReturnPageHeader" 
import shop from "shop/shop"
import Responsive from "react-responsive"
import {Button, Icon, Message, Modal, Form,Checkbox,Dropdown,TextArea} from "semantic-ui-react"
import { Link } from "react-router-dom"
import ReturnPageProgress from './ReturnPageProgress';
import DeliveryDatePicker from "components/Date/DeliveryDatePicker"
import moment from "moment"
import {
	Card,
	Col,
	FormField,
	FormInput,
	Row,Table
  } from "elemental-react16"
class ReturnPageContactPerson extends Component {
    state = {
        newcust: {
            address: {
                street: "",
                streetnumber: "",
                addition: "",
                postcode: "",
                city: "",
                country: "",
                street1: "",
                addition1: "",
                postcode1: "",
                city1: "",
                country1: "",
                deliverstreet: "",
                deliverstreetnumber: "",
                deliveraddition: "",
                deliverpostcode: "",
                delivercity: "",
                delivercountry: ""
            },
            contact: {
                email: shop.cart.getExtra("email") || "",
                email1:"",
                email2:"",
                phone: "",
                phone1: "",
                mobile: "",
                contact: shop.cart.getExtra("contact") || "",
                comment: shop.cart.getExtra("comment") || "",
                external: false
            },
            locale: "",
            deliveraddress: {
                streetnumber: "",
                street: "",
                addition: "",
                pcode: "",
                city: "",
                country: "",
                email: "",
                name1: "",
                name2: "",
                zusatz: "",
                phone: "",
                extras: {
                    freecontact: "",
                    addition: ""
                }
            },
            addressConfirmation: {
                streetnumber: "",
                street: "",
                addition: "",
                pcode: "",
                city: "",
                country: "",
                email: "",
                name1: "",
                name2: "",
                zusatz: "",
                phone: "",
                extras: {
                    freecontact: "",
                    addition: ""
                }
            }
        }
    }

    componentDidMount() {
        shop.cart.hooks.changed.add( this.updateCart )
        shop.cart.hydrate()
        shop.cart.update()
        console.log("shop.delivery", shop.cart)
        if (shop.delivery && shop.delivery[0]) {
            this.setState(prevState => ({
                newcust: {
                    ...prevState.newcust,
                    contact: shop.delivery[0].contact
                }
            }));
        }
      }

    handlePickUpDateChange = ( date ) => {
        let weekend = (moment(date, "DD.MM.YYYY").format("dddd").startsWith("So") || moment(date, "DD.MM.YYYY").format("dddd").startsWith("Sa")) ? true : false;
        if(weekend){
        shop.toast("Abholung nur Mo-Fr möglich", "error");
        shop.cart.setExtra( "pickupdate", "" )
        this.setState( { pickupdate: "" } )
        return;
        }
        let pickupdate = moment( date )
        if ( pickupdate.isValid() ) {
        pickupdate = pickupdate.format( "DD.MM.YYYY" )
        let pickupEnddate = moment(pickupdate, "DD.MM.YYYY").add(14, "days").format( "DD.MM.YYYY" )
        this.setState( { pickupdate } )
        shop.cart.setExtra( "pickupdate", pickupdate )
        shop.cart.setExtra( "pickupEnddate", pickupEnddate )
        } else {
        shop.cart.setExtra( "pickupdate", "" )
        this.setState( { pickupdate: "" } )
        }
        
    }

      handleChange = ( { product } ) => {
        shop.cart.add( product )
      }
      
      updateCart = () => {
        let products = getProducts()
        products = getProducts()
        this.setState( { products } )
        this.forceUpdate()
      }
      
      componentWillUnmount() {
        this.setState({productsTemp: shop.cart.products})
        shop.cart.hooks.changed.remove( this.updateCart )
      }

    handleInputChange = (event) => {
        const { name, value } = event.target;
        this.setState({ [name]: value });
    }

    handleSubmit = (event) => {
        event.preventDefault();
        console.log(this.state);
    }

    handleConfirmContact = async () => {
        console.log("handleConfirmContact PRE",shop.delivery)
        await shop.cart.setExtra( "contact", this.state.newcust.contact.contact )
        await shop.cart.setExtra( "comment", this.state.newcust.contact.comment )
        await shop.cart.setExtra( "email", this.state.newcust.contact.email )
        await shop.cart.setExtra( "phone", this.state.newcust.contact.phone )
        await shop.cart.setExtra( "external", this.state.newcust.contact.external )
    }


    handleForward =  async () => {
        console.log("handleForward RETURN",this.state.newcust.contact)
        await shop.cart.setExtra( "contact", this.state.newcust.contact.contact )
        await shop.cart.setExtra( "comment", this.state.newcust.contact.comment )
        await shop.cart.setExtra( "email", this.state.newcust.contact.email )
        await shop.cart.setExtra( "phone", this.state.newcust.contact.phone )
        await shop.cart.setExtra( "external", this.state.newcust.contact.external )
        this.props.history.push( "/return/confirmation" )
    }


    render() {
        let { pickupdate, contact, email, comment} = shop.cart.data.extras
        if(!shop.delivery){
            console.log("shop.delivery is empty")

        }

        const lieferzeitraum = shop.cart.getExtra("lieferzeitraum") 
        //console.log("shop.",shop.delivery)
        const handleChange = async (event) => {
            //console.log("CHANGE: ", event.target)
            let tempname = event.target.name
            let tempname2 = event.target.className
            let tempvalue = event.target.value
            await this.setState(prevState => {
                let newcust = { ...prevState.newcust };  
                newcust[tempname][tempname2] = tempvalue;       
                return { newcust }; 
              })
              this.handleConfirmContact()
          }; 

    
        const handleCommentChange = async ( event ) => {
        //console.log("VALUE:",event.target)
        let comment = event.target.value
        if(comment.length > 80){
            shop.toast("Maximale Länge erreicht", "error")
            return;
        }
        await this.setState(prevState => {
            let newcust = { ...prevState.newcust };  
            newcust.contact.comment = comment;       
            return { newcust }; 
            })
            this.handleConfirmContact()
        }

        return (
            <Fragment>
                <section className="container pt2 pb2">
                    <ReturnPageProgress progress={2} />
                </section>
                <Responsive minWidth={790}>
                <div>
                <Table>
                <colgroup>
                    <col width="10%" />
                    <col width="12%" />
                    <col width="3%" />
                    <col width="55%" />
                </colgroup>
                <tbody>
                    <tr>
                        <td>
                            &nbsp;
                        </td>
                        <td className="pr4  pl4 v-top ReturnPageAlignment" >
                            <ReturnPageHeader className="v-top" activeStep={1} />
                        </td>
                        <td>
                            &nbsp;
                        </td>
                        <td className="pr4  pl4 v-top ReturnPageAlignment" >
                            <h1 style={{color:"#265a88", fontSize:40}}  className="pt5 tl"><b>Ansprechpartner</b></h1>
                            <Message style={{width: "80%", borderRadius: "25px"}}> 
                                <div>{translate( "Bitte tragen Sie Ihre Kontaktdaten ein.")}</div>
                            </Message>
                            <Form style={{width: "80%"}}>
					        <h3>{translate("Erreichbarkeit")}</h3>
                        {/*<Form.Field required>
							<label>{translate("Ansprechpartner")}</label>
							<input value={this.state.newcust.contact.contact} onChange={handleChange} className="contact" name="contact" nameadd="contact" placeholder="Ansprechpartner" />
						</Form.Field>*/}
                        <label className="fw5 f5 w-70">{translate( "Ansprechpartner" )}</label>
						<Form.Input id="braunShForms" width={8} required >
                            <input value={this.state.newcust.contact.contact} onChange={handleChange} className="contact" name="contact" nameadd="contact" placeholder="Ansprechpartner" />
                        </Form.Input>
                        
                        <label className="fw5 f5 w-70">{translate( "E-Mail" )}</label>
						<Form.Input id="braunShForms" required width={8}>
							<input value={this.state.newcust.contact.email} onChange={handleChange} className="email" name="contact" nameadd="email" placeholder={translate("E-Mail")} />
						</Form.Input>
                        {this.state.newcust.contact.email && this.state.newcust.contact.email.length > 5 && (!this.state.newcust.contact.email.includes('@') || !this.state.newcust.contact.email.includes('.')) && 
                            <label className="fw5 f5 w-70 red">{translate( "Bitte geben Sie eine gültige E-Mail-Adresse ein." )}</label>}

                        {/*<DeliveryDatePicker  date={pickupdate} onChange={this.handlePickUpDateChange}/> */}
                        <div className="fw5 f5 w-70 pt3 ">{translate( "Ihr Lieferzeitraum" )}</div>
                        <div className="fw7 f5 pb3 pt1">{lieferzeitraum}</div>

                        <label className="fw5 f5 w-70">{translate( "Anlieferhinweise" )}</label>
						{<FormField width={8} className="w-50" id="braunShForms"  htmlFor="supported-controls-input">
                            
							   <FormInput placeholder={translate( "Weitere Lieferhinweise" )} value={this.state.newcust.contact.comment} onChange={handleCommentChange} multiline/>
              			</FormField>}
  				</Form>
                        </td>
                    </tr>
                    <tr >
                        <td>
                        &nbsp;
                        </td>
                        <td>
                            &nbsp;
                        </td>
                        <td>
                            &nbsp;
                        </td>
                        <td>
                            <div style={{paddingTop: "50px",width: "80%"}} className="">
                            <Link to={{
                                pathname: `/return/quantity`,
                                search  : this.props.location.search
                            }}>
                                <Button style={{width: "100px", borderRadius: "25px" , height: "50px"}}
                                primary >
                                {translate( "Zurück" )}
                                <i className="icon-angle-right"/>
                                </Button>
                            </Link>
                                <Button style={{width: "250px", borderRadius: "25px", height: "50px"	}}
                                    className="fr"
                                    disabled={false}
                                    primary
                                    onClick={this.handleForward}
                                    >{translate( "Lieferdaten bestätigen" )}</Button>
                            </div>
                        </td>
                    </tr>
                    </tbody>
                </Table>
            </div>
                </Responsive>
                <Responsive maxWidth={789}>
                <table>
                <colgroup>
                    <col width="90%" />
                </colgroup>
                <tbody>
                    <tr className="bb b--black-10">
                        <td>
                        <div className="headerInline"><Button style={{backgroundColor: "#ffffff", maxWidth:"55px"}} 
                            onClick={() => (this.state.navHeader ? this.setState({navHeader : false}) : this.setState({navHeader : true}
                            ))}>
                                <Icon className="big bars tc" ></Icon>
                            </Button><span className="pt3 tc fw7 f2">Restanten</span></div>
                        {this.state.navHeader && <ReturnPageHeader className="v-top" activeStep={1} />}
                        </td>
                        </tr>
                        <tr>
                        <td className="tc pr2  pl2 v-top ReturnPageAlignment" >
                            <h1 style={{color:"#265a88", fontSize:40}}  className="tc"><b>Ansprechpartner</b></h1>
                            <Message className="tc" style={{width: "100%", borderRadius: "25px"}}>
                                <div>{translate( "Bitte tragen Sie Ihre Kontaktdaten ein.")}</div>
                            </Message>
                            <Form className="pl3 pr3">
                                <h3>{translate("Erreichbarkeit")}</h3>
                                <div className="tl">
					        
                            {/*<Form.Field required>
							<label>{translate("Ansprechpartner")}</label>
							<input value={this.state.newcust.contact.contact} onChange={handleChange} className="contact" name="contact" nameadd="contact" placeholder="Ansprechpartner" />
						</Form.Field>*/}
                        <label className="fw5 f5 w-70">{translate( "Ansprechpartner" )}</label>
						<Form.Input width={16} required><input value={this.state.newcust.contact.contact} onChange={handleChange} className="contact" name="contact" nameadd="contact" placeholder="Ansprechpartner" /></Form.Input>

                        <label className="fw5 f5 w-70">{translate( "E-Mail" )}</label>
						<Form.Field className="" required>
							<input value={this.state.newcust.contact.email} onChange={handleChange} className="email" name="contact" nameadd="email" placeholder={translate("E-Mail")} />
						</Form.Field>

                        <div className="fw5 f5 w-70 pt3 ">{translate( "Ihr Lieferzeitraum" )}</div>
                        <div className="fw7 f5 pb3 pt1">{lieferzeitraum}</div>

                        <label className="fw5 f5 w-70">{translate( "Anlieferhinweise" )}</label>
						{<FormField htmlFor="supported-controls-input">
							   <FormInput placeholder={translate( "Lieferhinweise" )} value={this.state.newcust.contact.comment} onChange={handleCommentChange} multiline/>
              			</FormField>}
                        </div>
  				</Form>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <div className="tl">
                            <Link to={{
                                pathname: `/return/quantity`,
                                search  : this.props.location.search
                            }}>
                                <Button style={{width: "100px", borderRadius: "25px", height: "50px"	}}
                                primary >
                                {translate( "Zurück" )}
                                <i className="icon-angle-right"/>
                                </Button>
                            </Link>
                                <Button style={{width: "250px", borderRadius: "25px", height: "50px"	}}
                                    className="fr"
                                    disabled={false}
                                    primary
                                    onClick={this.handleForward}
                                    >{translate( "Kontaktdaten bestätigen" )}</Button>
                            </div>
                        </td>
                    </tr>
                        </tbody>
                        </table>
                </Responsive>
            </Fragment>
        );
    }
}

const getProducts = () => shop.cart.map( ( product ) => product)

export default ReturnPageContactPerson;


// WEBPACK FOOTER //
// ./src/theme/braunsheitmannShop/pages/returnCheckout/ReturnPageContactPerson.js